

<div class="d-flex flex-column justify-content-center align-items-center" style="height: 720px;">
    <div *ngIf="pdfRenderizado" class="d-flex w-100 align-items-center justify-content-between flex-row">
        <div>
            <button class="btn btn-secondary" (click)="zoomOut()"><i class="fa-solid fa-magnifying-glass-minus"></i></button>
            <button class="btn btn-secondary ms-2" (click)="zoomIn()"><i class="fa-solid fa-magnifying-glass-plus"></i></button>
            <button class="btn btn-secondary ms-2" (click)="download()"><i class="fa-solid fa-cloud-arrow-down"></i></button>
        </div>
        <div>
            <button class="btn btn-primary ms-2" [disabled]="disabledButtons(1)" (click)="prevPage()"><i class="fa-solid fa-circle-chevron-left"></i></button>
            <button class="btn btn-primary ms-2" [disabled]="disabledButtons(2)" (click)="nextPage()"><i class="fa-solid fa-circle-chevron-right"></i></button>
        </div>
    </div>
    <div class="pdf-visual">
        <canvas #pdfCanvas id="pdfCanvas"></canvas>
    </div>
    <button (click)="cerrarDialog()" class="btn btn-danger btn-width mt-2 mb-2">Cerrar Visualizador</button>
</div>

